module.exports = __webpack_public_path__ + "static/media/headerImg.69a5c25e.jpg";